export default __webpack_public_path__ + "static/PAPC-832-29a7760b173951383dd98c304bb313b6.jpg";